<template>
  <div class="upload-container">
    <div>{{ fileName }}</div>
    <div class="progress-container">
      <div class="progress-bar"></div>
    </div>
    <div class="upload-text">Uploading...</div>
  </div>
</template>
  
<script>
export default {
  props: ["fileName"],
};
</script>
  
<style lang="css" scoped>
.upload-container {
  width: 50%;
  border: 1px dashed #ccc;
  padding: 5px;
  text-align: left;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}
.progress-container {
  width: 100%;
  background-color: #f3f3f3;
  border-radius: 5px;
  margin-top: 10px;
  height: 8px;
  position: relative;
}
.progress-container {
  width: 100%;
  background-color: #f3f3f3;
  border-radius: 5px;
  margin-top: 10px;
  height: 8px;
  position: relative;
}
.progress-bar {
  width: 100%; /* Adjust this width to simulate the progress */
  height: 100%;
  background-image: linear-gradient(
    45deg,
    #428bca 25%,
    #DCDCDC 25%,
    #DCDCDC 50%,
    #428bca 50%,
    #428bca 75%,
    #DCDCDC 75%,
    #DCDCDC
  );
  background-size: 40px 40px;
  animation: progress 1s linear infinite;
  border-radius: 5px;
}
.upload-text {
  margin-top: 10px;
  color: #333;
}
@keyframes progress {
  100% {
    background-position-x: 2.5rem;
  }
}
</style>
  